/** @typedef {{ title: string, id: string, tagIds: number[], audienceIds: number[], region: string }} ShortPageObj */

export default class ShortPage {

    /**
     * @param {string} title 
     * @param {number []} tagIds 
     * @param {number []} audienceIds 
     * @param {string} id 
     * @param {string} region
     */
    constructor( title, tagIds, audienceIds, id, region ) {
        this.title = title;
        this.tagIds = tagIds;
        this.audienceIds = audienceIds;
        this.id = id;
        this.region = region;

        this.tags = [];
        this.audiences = [];
    }

    /**
     * @param {Tag []} tags 
     */
    setTags( tags ) {
        this.tags = tags;
        return this;
    }

    /**
     * @param {Tag []} audiences 
     */
    setAudiences( audiences ) {
        this.audiences = audiences;
        return this;
    }

    /**
     * @param {ShortPageObj} obj 
     */
    static fromObject( obj ) {
        return new ShortPage( obj.title, obj.tagIds, obj.audienceIds, obj.id, obj.region );
    }

}